module.exports = {
  BANK_LIST: 'bank_list',
  ENTITY_LIST: 'entity_list',
  SEND_PAYMENT_LIST: 'send_payment_list'
};
